module.exports = __webpack_public_path__ + "img/stableDiffusion.1ba2676d.png";